import { Button } from './button';
import { Container } from './container';
import { Divider } from './divider';
import { Heading } from './heading';
import { Input } from './input';
import { Link } from './link';
import { Menu } from './menu';
import { Modal } from './modal';
import { Skeleton } from './skeleton';
import { Tag } from './tag';
import { Text } from './text';
import { Tooltip } from './tooltip';

export const components = {
  Button,
  Container,
  Divider,
  Heading,
  Input,
  Link,
  Menu,
  Modal,
  Skeleton,
  Tag,
  Text,
  Tooltip,
};
